import React, { Component } from "react"
import { connect } from "react-redux"
import { requestResource } from "home/api_request"
import { EnemAnswerResultTablePresentation } from "home/components/enem_proficiency_analysis"
import TableWrapper from "home/components/table_wrapper"

const RESOURCE = "enem_proficiency_analysis/answer_result"

class EnemAnswerResultTableContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tableData: {
        data: null,
        columns: null
      }
    }
  }

  componentDidMount () {
    this.updateData()
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps.filters) != JSON.stringify(this.props.filters)) {
      this.updateData()
    }
  }

  updateData () {
    const { filters } = this.props

    requestResource(RESOURCE, filters, response => this.setChartConfigFromResponse(response))
  }

  setChartConfigFromResponse (response) {
    this.setState({
      tableData: response.data
    })
  }

  render () {
    return (
      <TableWrapper
        presenter={EnemAnswerResultTablePresentation}
        tableData={this.state.tableData}
        resource={RESOURCE}
        filters={this.props.filters}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    filters: {
      userId: state.filters.userId,
      schoolYear: state.filters.schoolYear,
      schoolClass: state.filters.schoolClass,
      schoolId: state.filters.schoolId,
      "enemAnalysis/answerResult/examId": state.filters["enemAnalysis/answerResult/examId"]
    }
  }
}

export default connect(mapStateToProps)(EnemAnswerResultTableContainer)
